import './Style.css';
import Navbar from '../components/Navbar';
import { useState } from 'react';
import Select from 'react-select';

const Registration = () => {
  // eslint-disable-next-line no-unused-vars
  const [option, setOption] = useState('');
  const roleChoice = [
    { value: 'coder', label: 'Coder' },
    { value: 'arbiter', label: 'Arbiter' },
  ];

  const selectStyle = {
    control: (styles) => ({ ...styles, backgroundColor: '#D9D9D9' }),
    option: (styles, { isFocused}) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#c85250" : null,
        color: "black"
      };
    }
  };

  return (
    <>
      <Navbar />
      <div className = "center-box">
        <form className="body-container">
          <h1 className="headline"> ICD-10 Portal User Registration </h1>
          <div className="input-form">
            <input className="input" placeholder="Full Name" />
            <input className="input" placeholder="Username" />
            <input className="input" placeholder="Email" />
            <input className="input" placeholder="Phone Number" />
            <input className="input" type="password" placeholder="Password" />
            <input className="input" type="password" placeholder="Confirm Password" />
          </div>
          <p className="body-text">Choose a role :</p>
          <Select
            name="role"
            options={roleChoice}
            className="basic-select"
            classNamePrefix="select"
            onChange={(value) => {
              setOption(value.value);
            }}
            styles = {selectStyle}
          />
          <button className="register-btn"> Register</button>
        </form>
      </div>
    </>
  );
};

export default Registration;
